var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmsLayout',[_c('EmsMonitor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }